import * as React from "react";

import ShareIcon from "@material-ui/icons/Share";
import { IconButton, Snackbar, Tooltip } from "@material-ui/core";

import { IButtonProps } from "./IButtonProps";

import { Analytics } from "Utility/Analytics";

const EndpointRoot = process.env.NODE_ENV === "production" ? "https://quilt.farm/q" : "https://localhost:44366/q";

export function ShareButton(props: IButtonProps): React.ReactElement {
    const [snackMessage, setSnackMessage] = React.useState<string | null>(null);
    const quiltRenderData = props.quiltRenderData;
    const disabled = quiltRenderData === null || props.disabled;

    const onClick = async () => {
        if (quiltRenderData === null) {
            return;
        }

        await navigator.clipboard.writeText(`${EndpointRoot}/${quiltRenderData.code}`);

        Analytics.shareQuilt(quiltRenderData.code);

        setSnackMessage("Quilt URL copied to clipboard.");
    }

    return (
        <>
            <Tooltip title="Copy quilt link">
                <span>
                    <IconButton size="small" color="primary" onClick={onClick} disabled={disabled}>
                        <ShareIcon/>
                    </IconButton>
                </span>
            </Tooltip>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={snackMessage !== null}
                autoHideDuration={3000}
                onClose={() => setSnackMessage(null)}
                message={snackMessage}
            />
        </>
    )
}